<template>
  <b-card>
    <!-- media -->
    <b-media no-body>
      <b-media-aside>
        <b-link>
          <!-- :src="getImageFullLink(optionsLocal.image)" -->
           <b-avatar
              size="40"
              :src="optionsLocal.image"
              variant="light-primary"
              badge
              class="badge-minimal"
              badge-variant="success"
            >
              <feather-icon v-if="!optionsLocal.image" icon="UserIcon" size="22" />
            </b-avatar>
        </b-link>
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="openUploadModal()"
        >
          Modifier image
        </b-button>
        <!--/ upload button -->
        <b-card-text
          >JPG, GIF ou PNG autorisés. Taille maximale de 1000 Ko</b-card-text
        >
      </b-media-body>
    </b-media>
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Nom de l'utilisateur"
            label-for="account-username"
          >
            <b-form-input
              v-model="optionsLocal.firstName"
              placeholder="Nom de l'utilisateur"
              name="username"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Prénom de l'utilisateur"
            label-for="account-last-name"
          >
            <b-form-input
              v-model="optionsLocal.lastName"
              name="account-last-ame"
              placeholder="Prénom de l'utilisateur"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="E-mail" label-for="account-e-mail">
            <b-form-input
              v-model="optionsLocal.email"
              name="email"
              placeholder="Email"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col sm="6">
          <b-form-group label="Company" label-for="account-company">
            <b-form-input
              v-model="optionsLocal.company"
              name="company"
              placeholder="Company name"
            />
          </b-form-group>
        </b-col> -->

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="saveSettings()"
          >
            Enregistrer
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import axios from "axios";

import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BAvatar
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BAvatar,
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      profileFile: null,
    };
  },
  methods: {
    resetForm() {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    },
    saveSettings() {
      axios
        .put(
          `https://management-projects.herokuapp.com/api/users/${
            JSON.parse(localStorage.getItem("userData"))._id
          }`,
          this.optionsLocal
        )
        .then((response) => {
          console.log("parametre",response)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Utilisateur bien Modifié`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la modification`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    openUploadModal() {
      window.cloudinary
        .openUploadWidget(
          { cloud_name: "dmdd546ps", upload_preset: "jhyzlocs" },
          (error, result) => {
            if (!error && result && result.event === "success") {
              console.log("Done uploading..: ", result);
              this.url = result.info.url;
              this.publicId = result.info.public_id;
              this.optionsLocal.image = this.publicId;
              //this.images=this.publicId; image here
            }
          }
        )
        .open();
    },
    getImageFullLink(image) {
      console.log(image);
      if (image) {
        return image;
      } else {
        return (
          "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" +
          image
        );
      }
    },
  },
  setup() {
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>
